module.exports = __webpack_public_path__ + "static/media/IlotD_synthese_18.348b1dab.webp";